import SortingArrows from './SortingArrows';

export default SortingArrows;
